<div class="page_layout">
  @for(cat of categories; track cat.id){ @if(cat.visible){
  <app-category-card
    [routerLink]="['/menuItems', cat.id]"
    [categoryId]="cat.id"
    (click)="onCategoryClicked(cat.id)"
  ></app-category-card>
  } }
  <app-menu-footer />
</div>
